import React, { HTMLAttributes } from 'react';

import { Video } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import { ImmutableParagraphVideoEntity } from '..';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphVideoEntity;
}

const ParagraphVideo: React.FC<Props> = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('ParagraphVideo');

  const embed = entity.getIn(['field_media_item', 0, 'embed'], '');

  if (embed) {
    return (
      <article className={joinClasses(className, buildClass())}>
        <Video url={embed} />
      </article>
    );
  }

  return null;
};

export default ParagraphVideo;
